export default __webpack_public_path__ + "static/media/v9ecqJI5EoSDyrx2JX7KHf1R2E13.ee6e31f5.jpg";